import { render, staticRenderFns } from "./VotePk.vue?vue&type=template&id=42e10dd6"
import script from "./VotePk.vue?vue&type=script&lang=ts"
export * from "./VotePk.vue?vue&type=script&lang=ts"
import style0 from "./VotePk.vue?vue&type=style&index=0&id=42e10dd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports